export default __webpack_public_path__ + "static/media/editIcon.523a4687.webp";